import React from "react";

import { canCorrectTaxonomy } from "byzantine/src/TransactionEnrichmentSource";

import CategorySelect from "../CategorySelect/CategorySelect";

import styles from "./CategoryCell.module.scss";

import type { TransactionCategory } from "../../hooks/useTransactionCategories";

interface CategoryCellProps {
  transaction: API.Transaction;
  categories: TransactionCategory[];
  canWrite: boolean;
}

const CategoryCell = ({
  transaction,
  categories,
  canWrite,
}: CategoryCellProps) => {
  // No categories means the taxonomy request is still in flight or has failed. A select with
  // nothing in it would be a dead control, and the request is not retried.
  if (!canCorrectTaxonomy(transaction, canWrite) || categories.length === 0) {
    return (
      <span
        className={styles.text}
        data-testid={`category-text-${transaction.id}`}
      >
        {transaction.category}
      </span>
    );
  }

  return (
    <div
      className={styles.cell}
      // The row opens the details panel when clicked, which would swallow every click meant for
      // the select and cover the column.
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
      data-testid={`category-cell-${transaction.id}`}
    >
      <CategorySelect
        transaction={transaction}
        categories={categories}
        selectId={`category-select-${transaction.id}`}
      />
    </div>
  );
};

export default CategoryCell;
